import { Spin } from "antd";
import React from "react";

const BaseSpin = (props) => {
	const {
		style = {
			position: "fixed",
			top: "50%",
			left: "50%",
			transform: "translate(-50%, -50%)",
			zIndex: 1001,
		},
	} = props;

	return <Spin {...props} style={style} />;
};

export default BaseSpin;
